/** The contact form's field rules for both forms and the server schema, on trimmed text as the server stores it. */

export type ContactField = 'name' | 'email' | 'message';

export type ContactFormErrors = Partial<Record<ContactField, string>>;

export const CONTACT_NAME_MAX = 100;
export const CONTACT_EMAIL_MAX = 255;
export const CONTACT_MESSAGE_MIN = 10;
export const CONTACT_MESSAGE_MAX = 5000;

export function contactFormErrors(form: Record<ContactField, string>): ContactFormErrors {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const errors: ContactFormErrors = {};
  const name = form.name.trim();
  const email = form.email.trim();
  const message = form.message.trim();

  if (!name) {
    errors.name = 'Name is required';
  } else if (name.length > CONTACT_NAME_MAX) {
    errors.name = `Name is too long (max ${CONTACT_NAME_MAX} characters)`;
  }

  if (!email) {
    errors.email = 'Email is required';
  } else if (!emailPattern.test(email)) {
    errors.email = 'Invalid email format';
  } else if (email.length > CONTACT_EMAIL_MAX) {
    errors.email = `Email is too long (max ${CONTACT_EMAIL_MAX} characters)`;
  }

  if (!message) {
    errors.message = 'Message is required';
  } else if (message.length < CONTACT_MESSAGE_MIN) {
    errors.message = `Message must be at least ${CONTACT_MESSAGE_MIN} characters`;
  } else if (message.length > CONTACT_MESSAGE_MAX) {
    errors.message = `Message is too long (max ${CONTACT_MESSAGE_MAX} characters)`;
  }

  return errors;
}
